var Flickity = require('flickity');

$(function () {
    initSliderItems('.slider-items');

    function initSlider(selector) {
        new Flickity(selector, {
            pageDots: false,
            prevNextButtons: false,
            on: {
                change: function (index) {
                    this.$element.parents('.slider-block').find('.slider__counter-current').text(index + 1)
                    setText($(this.selectedElement));
                },
                ready: function () {
                    var slider = this;

                    setText($(slider.selectedElement));
                    setTimeout(function () {
                        fast_background.update(function () {
                            slider.resize();
                        });
                    }, 400)

                    slider.$element.parents('.slider-block').find('.slider__controls-prev').click(function () {
                        slider.previous();
                    });

                    slider.$element.parents('.slider-block').find('.slider__controls-next').click(function () {
                        slider.next();
                    });

                    slider.$element.parents('.slider-block').find('[data-gallery-index-selector]').click(function () {
                        slider.selectCell($(this).data('gallery-index-selector'))
                    });
                }
            }
        });
    }

    function setText(el) {
        if (el.data('title') == '' && el.data('alt') == 0) {
            el.parents('.slider-block').find('.slider__title').closest('.slider__part').addClass('slider__part_hidden')
        } else {
            el.parents('.slider-block').find('.slider__title').closest('.slider__part').removeClass('slider__part_hidden')
        }
        el.parents('.slider-block').find('.slider__title').text(el.data('title'))
        el.parents('.slider-block').find('.slider__text').text(el.data('alt'))
    }

    $(document).on('initSlider', function (e, data) {
        var selector = '.slider-items:not(.flickity-enabled)';
        if(data !== undefined && data.selector !== undefined) {
            selector = data.selector;
        }

        initSliderItems(selector);
    })

    function initSliderItems(selector){
        if($(selector).length) {
            $(selector).each(function (i, el){
                initSlider( el );
            });
        }
    }
});
